import React, { 
    useState, useEffect
} from "react";

import { connect } from "react-redux";

import styles from "./Training.module.scss";
import * as qs from 'query-string';

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import PageHeader from "components/PageHeader/PageHeader";
import Button from "components/Button/Button";
import FormElement from "components/FormElement/FormElement";
import Select from "components/Select/Select";
import DateInput from "components/DateInput/DateInput"
import { toggleDropdowns } from "helpers/utils";

import {
    loadSitesAction,
    loadTrainingCoursesAction,
    loadTrainingAction,
    deleteTrainingAction,
    updateTrainingAction
} from "store/actions/Actions";

const TrainingEdit = props => {
    const [state, setState] = useState({
        actions:
            "Add actions as obj here, or add as separate properties to state",
        selectedRows: null,
        selected_course: {},
        selected_site: {},
        current_training: {},
        due: "",
        training: [],
        training_courses: [],
        sites: [],
    });

    const { SitesReducer, TrainingReducer, loadSitesAction, loadTrainingAction, loadTrainingCoursesAction } = props;
    const training_id = qs.parse(props.location.search).id;

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (!TrainingReducer.training) {
            loadTrainingAction();
        }
    }, [TrainingReducer.training, loadTrainingAction]);

    useEffect(() => {
        if (!TrainingReducer.training_courses) {
            loadTrainingCoursesAction();
        }
    }, [TrainingReducer.training_courses, loadTrainingCoursesAction]);

    useEffect(() => {
        if (SitesReducer.sites && TrainingReducer.training && TrainingReducer.training_courses) {
            const current_training = TrainingReducer.training.filter(training => training.id === training_id)[0];
            setState(s => ({
                ...s,
                sites: SitesReducer.sites,
                training_courses: TrainingReducer.training_courses,
                current_training: current_training,
                selected_course: {
                    id: current_training.training_course,
                    name: current_training.name
                },
                selected_site: {
                    id: current_training.site,
                    name: current_training.siteName
                },
                due: current_training.due,
                training: TrainingReducer.training
            }));
        }
    }, [TrainingReducer.training, TrainingReducer.training_courses, SitesReducer.sites, loadSitesAction, loadTrainingAction, loadTrainingCoursesAction, training_id]);

    const handleCourseChange = e => {
        setState({
            ...state,
            selected_course: {
                id: e.target.value,
                name: e.target.dataset.name
            }
        });
        // setStateErrors({
        //     ...stateErrors,
        //     course: ""
        // });
    }

    const handleSiteChange = e => {
        setState({
            ...state,
            selected_site: {
                id: e.target.value,
                name: e.target.dataset.name
            }
        });
        // setStateErrors({
        //     ...stateErrors,
        //     site: ""
        // });
    }

    const handleChange = inputName => e => {
        setState({
            ...state,
            [inputName]:
                e.target.type === "checkbox"
                    ? e.target.checked
                    : e.target.value || ((e.target && e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || '')
        })
        // setStateErrors({
        //     ...stateErrors,
        //     "due": ""
        // });
    }

    const courseDropdownRef = React.createRef();
    const siteDropdownRef = React.createRef();

    const saveTraining = async () => {
        // if (!state.selected_course.name || !state["due"] || !state.selected_site.name) {
        //     setStateErrors({
        //         ...stateErrors,
        //         course: !state.selected_course.name ? "Course is required" : "",
        //         "due": !state["due"] ? "Target date is required" : "",
        //         site: !state.selected_site.name ? "Site is required" : ""
        //     });
        //     return
        // }
        try {
            const course = {
                id: training_id,
                training_course: state.selected_course.id,
                assigned: state.current_training.assigned,
                due: state.due,
                site: state.selected_site.id,
                completed: state.current_training.completed,
            };
            await props.updateTrainingAction(course);
            props.history.push(`/achieve/training`);

        } catch (error) {
            console.log('Error in updateTrainingAction');
        }

    }

    return (
        <AppLayoutWrapFull
            onClick={toggleDropdowns([
                courseDropdownRef,
                siteDropdownRef
            ])}
        >
            <PageHeader
                // className={`${styles["page-header"]} ${
                //     showDescription ? styles["show-description"] : ""
                // }`}
            >
            </PageHeader>
            <Container fluid>
                <p className={styles["modal-heading"]}>Edit Training</p>

                <br />

                <div style={{ display: "flex" }}>
                    <FormElement
                        labelText="COURSE NAME"
                        htmlFor="course"
                        // errorMessage={stateErrors.course}
                    >
                        <Select
                            value={state.selected_course.name}
                            placeholder="Select course"
                            onClick={handleCourseChange}
                            dropdownToggleRef={courseDropdownRef}
                        >
                            {state.training_courses.map(course => {
                                    return <li key={`courseid-${course.id}`} data-name={course.name} value={course.id}>{course.name}</li>
                                }
                            )}

                        </Select>
                    </FormElement>
                </div>

                <br />
                <br />

                <FormElement
                    labelText="SITE"
                    htmlFor="description"
                    // errorMessage={stateErrors.description}
                >
                    <Select
                        value={state.selected_site.name}
                        placeholder="Select Site"
                        onClick={handleSiteChange}
                        dropdownToggleRef={siteDropdownRef}
                    >
                        {state.sites && state.sites.map(site => <li key={`siteid-${site.id}`} data-name={site.name} value={site.id}>{site.name}</li>)}

                    </Select>
                </FormElement>

                <br />
                <br />

                <FormElement
                    labelText="DUE DATE"
                    htmlFor="due"
                    // errorMessage={stateErrors["due"]}
                >
                    <DateInput
                        onChange={handleChange("due")}
                        value={state["due"]}
                    />
                </FormElement>

                <br />
                <br />

                <div style={{ display: "flex", justifyContent: 'center' }}>
                    <Button
                        text="BACK"
                        color="secondary"
                        onClick={() => props.history.push(`/achieve/training`)}
                    />
                    
                    <Button
                        text="SAVE TRAINING"
                        className={styles.create}
                        onClick={saveTraining}
                    />
                </div>

            </Container>
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = state => ({
    SitesReducer: state.SitesReducer,
    TrainingReducer: state.TrainingReducer,
});

const mapDispatchToProps = {
    loadSitesAction,
    loadTrainingCoursesAction,
    loadTrainingAction,
    deleteTrainingAction,
    updateTrainingAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TrainingEdit);
